import {
    createAsyncThunk
} from '@reduxjs/toolkit';
import {
    api
} from '../../helpers/api_helper';
import Log from '../../Services/Log';
import {
    API_ENDPOINTS
} from '../../constants/apiEndPoints';


export const getLiveAds = createAsyncThunk('ads/getLiveAds', async (status, thunkAPI, {
    page,
    limit
}) => {
    try {
        const response = await api.create(`${API_ENDPOINTS.ADS.GET_ALL}, status}`);
        // console.log(response)
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});

export const getAllAds = createAsyncThunk(
    'ads/getAllAds',
    async ({
        status,
        page = 1,
        limit = 6
    }, thunkAPI) => { // destructure page and limit
        try {
            const response = await api.create(
                `${API_ENDPOINTS.ADS.GET_ALL}?page=${page}&limit=${limit}`, // dynamically set page and limit
                status
            );
            console.log('response liveads' , response)
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const getAdPlan = createAsyncThunk('ads/plan', async (thunkAPI) => {
    try {
        const response = await api.get(API_ENDPOINTS.ADS.GET_AD_PLAN);
        // console.log('plan details', response.data)
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data)
    }
})

export const createAd = createAsyncThunk('ads/create', async (dataToSend, thunkAPI) => {
    try {
        const response = await api.create(API_ENDPOINTS.ADS.CREATE_AD, dataToSend);
        return response.data;
    } catch (error) {
        // console.error('Error in creating ad', error); // Log the entire error object
        if (error.response) {
            return thunkAPI.rejectWithValue(error.response.data);
        } else {
            return thunkAPI.rejectWithValue({
                error: error.message
            });
        }
    }
});

export const updateAd = createAsyncThunk('ads/update', async (dataToSend, thunkAPI) => {
    try {
        const response = await api.create(API_ENDPOINTS.ADS.UPDATE, dataToSend);
        return response.data;
    } catch (error) {
        if (error.response) {
            return thunkAPI.rejectWithValue(error.response.data);
        } else {
            return thunkAPI.rejectWithValue({
                error: error.message
            });
        }
    }
});